module.exports = __webpack_public_path__ + "assets/53c68bc227ec36e42e4194b7f28424bc.png";